export default "__VITE_ASSET__9tgyk0o4__"